import React, { useState, useEffect } from 'react';
import { Drawer, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import BotaoSalvar from '../Botoes/BotaoSalvar';
import {
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  DrawerFooter,
} from './styles';

interface FiltrosDrawerProps {
  open: boolean;
  onClose: () => void;
  title: string;
  subtitle: string;
  onApply: () => void;
  applyButtonText?: string;
  children: React.ReactNode;
}

const FiltrosDrawer: React.FC<FiltrosDrawerProps> = ({
  open,
  onClose,
  title,
  subtitle,
  onApply,
  applyButtonText = 'Aplicar Filtros',
  children,
}) => {
  const [drawerWidth, setDrawerWidth] = useState(500);

  useEffect(() => {
    const updateDrawerWidth = (): void => {
      setDrawerWidth(window.innerWidth < 768 ? window.innerWidth : 500);
    };

    updateDrawerWidth();
    window.addEventListener('resize', updateDrawerWidth);

    return () => {
      window.removeEventListener('resize', updateDrawerWidth);
    };
  }, []);

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        style: { width: drawerWidth },
      }}
    >
      <DrawerContent>
        <DrawerHeader>
          <div>
            <h1>{title}</h1>
            <p>{subtitle}</p>
          </div>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </DrawerHeader>
        <DrawerBody>{children}</DrawerBody>
        <DrawerFooter>
          <BotaoSalvar onClick={onApply}>{applyButtonText}</BotaoSalvar>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};

export default FiltrosDrawer;

